<div class="payment-progress-container mt-5  mx-auto text-center">
  <div id="lottie"></div>
</div>
